module.exports = __webpack_public_path__ + "img/browser2.b64112b2.png";